import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { G2S } from 'core/g2s';
import * as api from 'core/api';
import * as flights from 'core/flights';
import * as utils from 'core/utils';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class ProductServiceComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    product: flights.ProductModel;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    @Prop()
    gaAlreadySubmitted: string[];

    isProductSelected: string = '';

    alreadyInPackageModal = {
        message: '',
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        acceptCallback: () => { },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        refuseCallback: () => { }
    }

    mounted() {
        const stepNumber = this.product.product.stepNumber;
        const kitId = this.product.product?.kitId || '';
        const id = this.product.product.id;
        const label = `product.step${stepNumber}.kit${kitId}.id${id}`;

        if (!this.gaAlreadySubmitted.includes(label)) {
            (<any>this).$ga.sendEvent('product',
                'display',
                label,
                this.gaParams
            );
            this.gaAlreadySubmitted.push(label);
        }

        if (!this.product.needToSelect) {
            if (this.product.selected) {
                this.isProductSelected = 'buttonText1';
            } else {
                this.isProductSelected = 'buttonText3';
            }
        }
    }

    get relatedProducts() {
        return this.reservation.getPackageRelatedProductsByExternalId(this.product!.product.externalId) || [];
    }

    getProductIcon(product: flights.ProductModel): string {
        let urlPrefix = '/i/icons/lg/';

        if (G2S.config.theme === 'aviasales') {
            urlPrefix = '/themes/aviasales/i/icons/lg/';
        }

        return urlPrefix + (product.product.details.iconLarge ? product.product.details.iconLarge : 'empty') + '.svg';
    }

    onProductDetails(product: flights.ProductModel) {
        (<any>this).$ga.sendEvent('product',
            'detail',
            `product.step${product.product.stepNumber}.kit${product.product!.kitId || ''}.id${product.product.id}`,
            this.gaParams
        );

        this.$emit('product-details', product);
    }

    changeProductSelection(product: flights.ProductModel) {
        if (product.product.id == 15 && this.product.selected == true && !!0) { // временное ограничение на показ окна
            (<any>this.$root).$refs.dialogMessage.show({
                text: 'Вы уверены, что хотите отказаться от услуги <b>Возврат без потерь</b> и остаться без компенсации в случае возврата билета?',
                btnOkLabel: 'Оставить услугу в заказе',
                persistent: true,
                btnOkColorClass: 'btn-alternate',
                btnCancelColorClass: 'btn-outline-alternate',
                btnOkHandler: function(){
                    (<any>this).$refs.dialog.isActive = false;
                },
                btnCancelLabel: 'Отказаться от услуги',
                btnCancelHandler: () => {
                    this.product.selected = !this.product.selected;
                },
                btnCloseHandler: () => {
                    this.product.selected = !this.product.selected;
                }
            });
        } else {
            this.product.selected = !this.product.selected;
        }
        if (this.product.selected && product) {
            product.choiceType = api.ProductChoiceType.confirmationAccepted;
        } else if (product) {
            product.choiceType = api.ProductChoiceType.confirmationDenied;
        }

        (<any>this).$ga.sendEvent('product',
            this.product.selected ? 'btn.ok' : 'btn.cancel',
            `product.step${this.product.product.stepNumber}.kit${this.product.product!.kitId || ''}.id${this.product.product.id}`,
            this.gaParams
        );

        this.$emit('product-selection-change', product, this.product.selected);
    }

    onProductSelectionChange(product: flights.ProductModel, localValue: string) {
        let value: boolean = false;

        switch(localValue) {
            case 'buttonText1':
                value = true;
                break;
            case 'buttonText2':
                value = true;
                break;
            case 'buttonText3':
                value = false;
                break;
        }

        const prevNeedToSelect = this.product.needToSelect;
        this.product.selected = value;
        this.product.needToSelect = false;

        if (value) {
            new api.RetailRocket().productSelected({
                flightKey: api.RetailRocketCL.flightKey,
                productId: product.product.id,
                bookingSessionId: this.reservation.bookingSessionId ?? undefined
            });
        }

        if (value && product.product.additionalProcessing) {
            this.$nextTick(() => {
                (<any>this.$root).$refs.dialogMessage.show({
                    text: 'Извините, услуга сейчас недоступна, но вы сможете купить ее позже ❤️',
                    btnOkLabel: 'OK',
                    persistent: true,
                    btnOkColorClass: 'btn-alternate',
                    btnOkHandler() {
                        (<any>this).$refs.dialog.isActive = false;
                    }
                });
                this.product.selected = false;
                this.isProductSelected = 'buttonText3';
            });
            return;
        }

        this.isProductSelected = localValue;

        /// Проверка на наличие пакета в выбранных
        if(localValue == 'buttonText1' || localValue == 'buttonText2'){
            this.reservation.selectedProducts.forEach(item => {
                if(item.product.internalProductIds){
                    item.product.internalProductIds.forEach(inPackage => {
                        if(inPackage == product.product.id) {
                            // Вызов модалки
                            (<any>this.$root).$refs.dialogMessage.show({
                                text: `Эта услуга уже есть в <b>${item.product.name}</b>`,
                                btnOkLabel: 'Ok',
                                persistent: true,
                                btnOkColorClass: 'btn-alternate',
                                btnOkHandler: function(){
                                    (<any>this).$refs.dialog.isActive = false;
                                }
                            });
                            product.selected = false;
                            return 0;
                        }
                    });
                }
            });
        }

        if(product.product.id == 15 && localValue == 'buttonText3' && !prevNeedToSelect && !!0) { // временное ограничение на показ окна
            (<any>this).$ga.sendEvent(
                'product.popup',
                'display',
                `product.popup.step${this.product.product.stepNumber}.kit${this.product.product!.kitId || ''}.id${this.product.product.id}`,
                this.gaParams
            );
            (<any>this.$root).$refs.dialogMessage.show({
                text: 'Вы уверены, что хотите отказаться от услуги <b>Возврат без потерь</b> и остаться без компенсации в случае возврата билета?',
                btnOkLabel: 'Оставить услугу в заказе',
                persistent: true,
                btnOkColorClass: 'btn-alternate',
                btnCancelColorClass: 'btn-outline-alternate',
                btnOkHandler: () => {
                    (<any>this).$ga.sendEvent(
                        'product.popup',
                        'btn.ok',
                        `product.popup.step${this.product.product.stepNumber}.kit${this.product.product!.kitId || ''}.id${this.product.product.id}`,
                        this.gaParams
                    );
                    this.isProductSelected = 'buttonText1';
                    this.product.selected = true;
                },
                btnCancelHandler: () => {
                    (<any>this).$ga.sendEvent(
                        'product.popup',
                        'btn.cancel',
                        `product.popup.step${this.product.product.stepNumber}.kit${this.product.product!.kitId || ''}.id${this.product.product.id}`,
                        this.gaParams
                    );
                },
                btnCancelLabel: 'Отказаться от услуги'
            });
        }

        if (value) {
            product.choiceType = api.ProductChoiceType.manualAccepted;
        }

        (<any>this).$ga.sendEvent('product',
            value ? 'btn.ok' : 'btn.cancel',
            `product.step${this.product.product.stepNumber}.kit${this.product.product!.kitId || ''}.id${this.product.product.id}`,
            this.gaParams
        );
    }
}
